import { AxiosResponse } from 'axios'
import { getMarginsDetails } from '../../../api'

export const getBuyingPower = async (accntNum: string) => {
  return await getMarginsDetails(accntNum)
    .then(({ data: { overnightBuyingPower } }: AxiosResponse) => {
      return overnightBuyingPower
    })
    .catch(error => {
      return 'N/A'
    })
}
